/**
 * import all the modules
 */

import functions from './common/functions'
import gui from './common/gui'
import height from './common/height'
import events from './common/events'
import overlay from './common/overlay'
import cookies from './common/cookies'
import map from './common/map'
import pmlayers from './parkmap/pmlayers'
import pclayers from './parkmap/pclayers'
import legend from './common/legend'
import pcvector from './parkmap/vector_consult'
import consult from './parkmap/pccomments'
import search from './common/search'
import ruler from './common/ruler'
import marker from './common/marker'
import drawing from './common/drawing'
import popup from './common/popup'
import print from './common/print'


import psavector from './psa/vector_psa'
import psaeventstaff from './psastaff/events_psa_staff'
import fravector from './fra/vector_fra'
import fraeventstaff from './frastaff/events_fra_staff'


import amlayers from './accsmap/amlayers'
import amextras from './accsmap/amextras_plus'

import invlayers from './invmap/invlayers'
import fralayers from './frastaff/fralayers'
import psalayers from './psastaff/psalayers'

const init = () => {
  /**
   * Events listener
   */
  // use the previous functions on the load event
  document.addEventListener('DOMContentLoaded', () => {
    height.sizeContent()
    events.hideDiv()
  })

  document.addEventListener('scroll', () => {
    height.scrollContent()
  })

  // use the previous functions on the window resize event
  window.addEventListener('resize', () => {
    height.sizeContent()
    events.hideDiv()
    print.setModalSize()
  })

  /**
   * initialize Traffweb
   */
  var pageconfig = JSON.parse($('#pageconfig').val())

  functions.init()
    .then(() => functions.initMM())
    // initialize the map
    .then(() => map.mapInit())
    // initialize the interface
    .then(() => gui.initGui())
    // check for cookie
    .then(() => cookies.checkCookie(map.getMap(), false))
    // initialize the layer
    .then(() => pmlayers.initPmLayer())
    // add the layer
    .then(() => pmlayers.addlayer())
    // initialize the date for the layer and the datepicker
    .then(() => amlayers.initDate())
    // initialize date picker
    .then(() => amlayers.initDatePicker())
    // initialize the accident layer
    .then(() => amlayers.initAmLayer())
    // add the accident layer
    .then(() => amlayers.addlayer())
    // initialize the layer
    .then(() => invlayers.initInvLayer())
    // add the layer
    .then(() => invlayers.addlayer())
    // initialize the layer
    .then(() => fralayers.initFraLayer())
    // add the layer
    .then(() => fralayers.addlayer())
    // initialize the layer
    .then(() => psalayers.initPsaLayer())
    // add the layer
    .then(() => psalayers.addlayer())
    // update the layer
    .then(() => amlayers.updateLayerParams())
    // init pc layer - app specific so bypass if not consult
    .then(() => {if (pageconfig.appname.type === 'consult') {pclayers.initPcLayer()}})
    // add the layer
    .then(() => {if (pageconfig.appname.type === 'consult') {pclayers.addlayer()}})
    // initialize the legend
    .then(() => legend.initLegend())
    // initialize the search
    .then(() => search.search(map.getMap(), overlay.overlay))
      // initialize the update report parameters
    .then(() => {if (pageconfig.appname.type === 'accsmap' && pageconfig.report) {amextras.updateReportParams()}})
    // initialize the suspension search
    .then(() => {if (pageconfig.appname.type === 'psa' && pageconfig.private) {psaeventstaff.initSuspensionSearch(map.getMap(), overlay.overlay)}})
    // initialize the fault search
    .then(() => {if (pageconfig.appname.type === 'fra' && pageconfig.private) {fraeventstaff.initFaultSearch(map.getMap(), overlay.overlay)}})
    // initialize the fault report
    .then(() => {if (pageconfig.appname.type === 'fra' && pageconfig.private) {fraeventstaff.initReport()}})
    // initialis fra
    .then(() => {if (pageconfig.appname.type === 'fra' && !pageconfig.private) {fravector.initVector(map.getMap(), overlay.overlay, fralayers.fralayer())}})
    // initialis psa
    .then(() => {if (pageconfig.appname.type === 'psa' && !pageconfig.private) {psavector.initVector(map.getMap(), overlay.overlay, pmlayers.pmlayer())}})
    // initialize the ruler layers
    .then(() => ruler.initRuler(map.getMap(), overlay.overlay))
    // initialize the marker layers
    .then(() => marker.initMarker(map.getMap(), overlay.overlay))
    // initialize the vector layer
    .then(() => {if (pageconfig.appname.type === 'consult') {pcvector.initVector(map.getMap(), overlay.overlay)}})
    // initialize the button
    .then(() => {if (pageconfig.appname.type === 'consult') {consult.initPcForm()}})
    // initialize the drawing layers
    .then(() => drawing.initDrawing(map.getMap(), overlay.overlay))
    // initialize the events
    .then(() => events.initEvents(map.getMap(), overlay.overlay))
    // initialize the accsmap events
    .then(() => {if (pageconfig.appname.type === 'accsmap' && (pageconfig.print || pageconfig.report)) {amextras.initAmEvents(overlay.overlay)}})
    // initialize the popup
    .then(() => popup.infoPopup(map.getMap(), overlay.overlay))
    // initialize print
    .then(() =>  {if (pageconfig.print) {print.initPrint(map.getMap())}})

    pmlayers.initDatePicker()
    height.sizeContent()
}

/**
 * RUN THE APP
 */

init()
